import React from 'react';
import {Form, FormGroup, Label, Input, FormText,Badge,Button } from 'reactstrap';
import {resetPasswordRequest} from '../functions/resetPassword';

const required = (val) => val && val.length;
const validEmail = (val) => /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/i.test(val);

class EmailForgotPassword extends React.Component{
    constructor(props){
        super(props);
        this.state={
            email:"",
            errorServer:"",
            errorEmail:"",
            divEnterEmail:"",
            divEmailSent:"none",
            buttonName:"Submit"
        }
    }
    myChangeHandler = (event) => {
        let nam = event.target.name;
        let val = event.target.value;
        this.setState({[nam]: val});
    }

    validate = (event)=>{
        let nam = event.target.name;
        let val = event.target.value;
        console.log(nam)
        if(nam==="email" && !validEmail(val)){
            this.setState({errorEmail: "Invalid Email"});
        }
        else if(nam==="email" && validEmail(val)){
            this.setState({errorEmail:""});
        }
    }

    mySubmitHandler = (event) =>{
        event.preventDefault();
        if(validEmail(this.state.email)){
            this.setState({
                buttonName:"Sending..",
                divEnterEmail:"none",
                divEmailSent:""
            });
            resetPasswordRequest(this.state.email.toLowerCase())
            .then((resp)=>{
                if(resp){
                    if(resp.success){
                        this.setState({
                            divEnterEmail:"none",
                            divEmailSent:"",
                            errorServer:""
                        });
                    }
                    else{
                        this.setState({
                            errorServer:resp.message,
                            buttonName:"Submit"
                        });
                    }
                }
                else{
                    this.setState({
                        errorServer:"Try Again. Something Went Wrong.",
                        buttonName:"Submit"
                    });
                }
            })
        }
        else{
            this.setState({errorEmail: "Invalid Email"});
        }
    }

    render(){
        return(
            <div className="container">
                <div className="row justify-content-center login" style={{display:this.state.divEnterEmail}}>
                    <Form  onSubmit={this.mySubmitHandler}>
                        <FormGroup>
                            <Label for="email">Enter Email</Label>
                            <Input
                                className="col"
                                id="email"
                                type='text'
                                name='email'
                                onChange={this.myChangeHandler}
                                value={this.state.email}
                                onBlur={this.validate}
                            />
                            <FormText color="danger">{this.state.errorEmail}</FormText>
                        </FormGroup>
                        <input type="submit" value={this.state.buttonName}/>
                        <FormText color="danger">{this.state.errorServer==="Failed to fetch"?"Server is down. Please try again":""}</FormText>
                    </Form>
                    <div >
                        {/* <h4><Badge color="danger">{this.state.errorLogin}</Badge></h4> */}
                    </div>
                </div>
                <div  className="mt-3" style={{display:this.state.divEmailSent}}>
                    <h4><Badge color="success">Check your Email {this.state.email}</Badge></h4>
                    <h5>Link to Reset your password has been sent to your Email.</h5>
                    <h5>Please check <strong>Spam</strong> Folder</h5>
                </div>
            </div>
        );
    }
}

export default EmailForgotPassword;